import { gql } from '@apollo/client'

export const MUTATION_SCHEDULED_CANCELLATION = gql`
  mutation mutationScheduledCancellation($input: ScheduledCancellationInput!) {
    scheduledCancellation(input: $input) {
      id
    }
  }
`
